import { FC } from 'react';
import { SelfServiceAPI } from 'types';
import { FormattedName } from 'components/Formatters';
import { ContentHeading } from 'components/Typography';
import EditButton from './components/EditButton';
import GuestInformationCard from '../GuestInformationCard';
import GuestDetailsModal, { GuestAmendmentProvider } from 'components/GuestDetailsModal';
import useLocalModal from 'hooks/useLocalModal';

interface GuestInformationProps {
  booking: SelfServiceAPI.Booking;
}

const GuestInformation: FC<GuestInformationProps> = ({ booking }) => {
  const { reservation, travelArranger } = booking;
  const leadGuestName = <FormattedName name={reservation.leadGuest.name} />;

  const {
    openModal,
    closeModal,
    modalProps: { isOpen },
  } = useLocalModal();

  return (
    <>
      <ContentHeading>
        Guest information <EditButton booking={booking} openModal={openModal} data-testid="edit-guest-information" />
      </ContentHeading>
      <GuestInformationCard
        leadGuestName={leadGuestName}
        guestQffNumber={reservation.leadGuest.qffNumber}
        guestAbnNumber={travelArranger.businessRegistrationNumber}
        guestPhoneNumber={travelArranger.phone}
        guestEmailAddress={travelArranger.email}
      />
      {isOpen ? (
        <GuestAmendmentProvider>
          <GuestDetailsModal isOpen={isOpen} closeModal={closeModal} />
        </GuestAmendmentProvider>
      ) : null}
    </>
  );
};

export default GuestInformation;
